import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import TabBar from '@/components/tabBar';
import { ref, computed, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useVisitedViewStore } from '@/stores';
import WinActionMenu from './winActiveMenu.vue';
export default {
  name: 'XWinTab',
  components: {
    TabBar,
    WinActionMenu
  },
  props: {
    defaultPage: {
      type: String,
      default: '/'
    },
    group: {
      type: String,
      default: 'user'
    }
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const viewTabBarRef = ref(null);
    const viewStore = useVisitedViewStore();
    const activeView = computed(() => {
      return viewStore.groupActiveView(props.group);
    });
    watch(activeView, viewPath => {
      activeWinKeyRef.value = viewPath;
    });
    const activeWinKeyRef = ref('');
    const tabItems = computed(() => {
      return viewStore.groupViews(props.group);
    });
    onMounted(() => {
      activeWinKeyRef.value = activeView.value;
    });
    const doPathChanged = path => {
      const route = tabItems.value.find(t => t.path === path);
      if (!route) return;
      activeWinKeyRef.value = path;
      router.push({
        path: route.path,
        params: route.params,
        query: route.query
      });
    };
    const handleTabChanged = path => {
      doPathChanged(path);
    };

    // 关闭指定路径的tab
    const handleCloseTab = path => {
      removeViewTab(path);
    };
    const openHomePage = () => {
      const navPage = props.defaultPage ? props.defaultPage : '/';
      router.push({
        path: navPage
      });
    };
    const removeViewTab = path => {
      const route = tabItems.value.find(t => t.path === path);
      if (!route) return;
      let removeIdx = viewStore.delGroupView(props.group, {
        path: route.path,
        params: route.params,
        query: route.query,
        meta: {
          title: route.title,
          group: route.group,
          closable: route.closable
        }
      });
      if (removeIdx === -1) return;
      const len = tabItems.value.length;
      if (len === 0) {
        openHomePage();
      }
      let nextRoute = null;
      if (removeIdx < len) {
        nextRoute = tabItems.value[removeIdx];
      } else {
        removeIdx--;
        if (removeIdx >= 0 && removeIdx < len) {
          nextRoute = tabItems.value[removeIdx];
        }
      }
      if (nextRoute) {
        router.push({
          path: nextRoute.path,
          params: nextRoute.params,
          query: nextRoute.query
        });
      }
    };
    const removeOtherWinTabs = () => {
      viewStore.delOtherView(route);
    };
    const removeAllWinTabs = () => {
      viewStore.delGroupAllView(props.group);
      openHomePage();
    };

    // 关闭当前tab
    const closeCurrentTab = () => {
      removeViewTab(activeWinKeyRef.value);
    };

    // 关闭其他tab
    const closeOtherTabs = () => {
      removeOtherWinTabs();
    };

    // 关闭所有tab
    const closeAllTabs = () => {
      removeAllWinTabs();
    };
    context.expose({
      closeCurrentTab: closeCurrentTab,
      closeAllTabs: closeAllTabs,
      closeOtherTabs: closeOtherTabs
    });
    const handleTabMenuClick = menu => {
      switch (menu) {
        case 'closeCur':
          closeCurrentTab();
          break;
        case 'closeOther':
          closeOtherTabs();
          break;
        case 'closeAll':
          closeAllTabs();
          break;
      }
    };
    const handleWinMenuClick = menu => {
      const {
        path
      } = menu || {};
      if (!path) return;
      doPathChanged(path);
    };
    return {
      viewTabBarRef,
      activeWinKeyRef,
      tabItems,
      openHomePage,
      removeViewTab,
      removeOtherWinTabs,
      removeAllWinTabs,
      closeCurrentTab,
      closeOtherTabs,
      closeAllTabs,
      handleTabMenuClick,
      handleWinMenuClick,
      handleTabChanged,
      handleCloseTab
    };
  }
};